// @ts-nocheck
import { TabProps } from "@insite/mobius/Tab";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import commonTab from "@store/Themes/common/styleguide/components/tab";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const tab: Styleguide["tab"] = {
    ...commonTab,
    defaultProps: {
        ...commonTab?.defaultProps,
        css: css<TabProps>`
            ${commonTab?.defaultProps?.css}
            border-bottom: ${pxToRem(5)} solid ${getColor("common.border")};

            &:hover {
                font-weight: ${x => x.theme.design.typography.weight.bold};
                border-bottom: ${pxToRem(5)} solid ${getColor("primary")};
                color: ${getColor("primary")};
            }

            &[aria-selected="true"] {
                font-weight: ${x => x.theme.design.typography.weight.bold};
                border-bottom: ${pxToRem(5)} solid ${getColor("secondary")};
                color: ${getColor("secondary")};
            }
        `,
    },
    groupDefaultProps: {
        ...commonTab?.groupDefaultProps,
        cssOverrides: {
            ...commonTab?.groupDefaultProps?.cssOverrides,
            tabContent: css`
                ${commonTab?.groupDefaultProps?.cssOverrides?.tabContent}
                ${breakpointValues(pxToRemArray([26, 30, 36, null, 50]), "padding-top")}
            `,
        },
    },
};

export default tab;
